import { Rect, Svg } from 'react-native-svg'

interface FlagIconProps {
    width?: number
    height?: number
}

/** Ukraine — blue / yellow horizontal bicolour. */
const UaFlagIcon = ({ width = 28, height = 20 }: FlagIconProps) => (
    <Svg width={width} height={height} viewBox="0 0 28 20">
        <Rect width={28} height={10} fill="#005BBB" />
        <Rect y={10} width={28} height={10} fill="#FFD500" />
    </Svg>
)

export default UaFlagIcon
